import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { CrudService } from '../shared/services/crud.service';

@Injectable({
    providedIn: 'root'
})
export class TextService extends CrudService<ComponentText> {
    private subject = new Subject<boolean>();
    enableDisableResponse = this.subject.asObservable();
    enableDisableEdit(editing: boolean) {
        this.subject.next(editing);
    }

    constructor(protected http: HttpClient) {
        super(http, 'componentText');
    }

    text(alias: string, formConfigurationAlias: string): Observable<ComponentText> {
        return this.http.get<ComponentText>(
            `/api/${this.apiUrl}?alias=${alias}&formConfigurationAlias=${formConfigurationAlias}`
        );
    }

    mayEditAny(): Observable<any> {
        return this.http.get(`/api/${this.apiUrl}/mayEditTextComponents`);
    }

    toggleEditingMode(): Observable<any> {
        return this.http.get(`/api/${this.apiUrl}/toggleEditMode`);
    }

    currentlyEditing(): Observable<any> {
        return this.http.get(`/api/${this.apiUrl}/currentlyEditing`);
    }
}

export interface ComponentText {
    id: number;
    alias?: string;
    formConfigurationAlias?: string;
    text: string;
    interpolatedText?: string;
    isNew?: boolean;
    mayEdit: boolean;
}
